module.exports = __webpack_public_path__ + "static/media/organizations-active.dee499f4.svg";